import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

export const Container = styled.div`
  display: flex;
  gap: 12px;
  overflow-x: auto;
  overflow-y: hidden;
  height: 100%;
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
`;

interface DayPillProps {
  isSelected: boolean;
  isDisabled: boolean;
}

export const DayPill = styled.button<DayPillProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: clamp(4px, 0.5vw, 8px);
  flex: 1 1 auto;
  min-width: clamp(80px, 15%, 120px);
  max-width: 100px;
  padding: clamp(8px, 2vh, 10px) clamp(16px, 2vw, 24px);
  border-radius: 50px;
  border: 2px solid
    ${({ isSelected, theme }: { isSelected: boolean; theme: any }) =>
      isSelected ? theme.primaryColour : '#e0e0e0'};
  background-color: ${({
    isSelected,
    isDisabled,
    theme,
  }: {
    isSelected: boolean;
    isDisabled: boolean;
    theme: any;
  }) => {
    if (isDisabled) return theme.greyColors['grey-10'];
    if (isSelected) return theme.primaryColour;
    return '#ffffff';
  }};
  color: ${({ isSelected, isDisabled, theme }) => {
    if (isDisabled) return theme.greyColors['grey-30'];
    if (isSelected) return '#ffffff';
    return '#333333';
  }};
  cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'pointer')};
  transition: all 0.2s ease;
  font-family: inherit;

  &:hover {
    ${({ isDisabled, isSelected, theme }) =>
      !isDisabled &&
      !isSelected &&
      `
      border-color: ${theme.primaryColour};
      background-color: ${theme.primaryColour || '#f0f7ff'};
      color: #ffffff;
      opacity: 0.6;
    `}
  }

  .day-number,
  .day-month {
    font-size: clamp(14px, 1.2vw, 17px);
    font-weight: 500;
    line-height: 1;
  }

  .day-month {
    text-transform: capitalize;
  }

  ${media.md`
    min-width: clamp(90px, 15%, 130px);
    gap: clamp(6px, 0.6vw, 10px);
  `}
`;
